
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recently-played",
      function () {
        return require("private-next-pages/recently-played.js");
      }
    ]);
  